import { render, staticRenderFns } from "./DetallePlanificacionAnualTabla.vue?vue&type=template&id=5b4fb036&scoped=true"
import script from "./DetallePlanificacionAnualTabla.vue?vue&type=script&lang=js"
export * from "./DetallePlanificacionAnualTabla.vue?vue&type=script&lang=js"
import style0 from "./DetallePlanificacionAnualTabla.vue?vue&type=style&index=0&id=5b4fb036&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4fb036",
  null
  
)

export default component.exports